export const checkCenterLng = (
	showHoleMarker,
	singleSiteLocationData,
	site,
	singleLocationLat,
	carData
) => {
    if ((showHoleMarker && singleSiteLocationData) || site) {
      return singleLocationLat[0]?.CenterPointLongitude;
    } else if (singleSiteLocationData) {
      return singleLocationLat[0]?.CenterPointLongitude;
    } else if (carData) {
      return carData[0]?.Car?.Longitude;
    } else if (singleLocationLat.length > 0) {
      return singleLocationLat[0]?.CenterPointLongitude;
    } else {
      return -105.52712;
    }
  };